import { createAction, emptyProps, props } from "@ngrx/store";

export const FETCH_CURRENT_LOCATION = createAction(
    'FETCH_CURRENT_LOCATION',
    emptyProps
);

export const FETCHED_CURRENT_LOCATION = createAction(
  'FETCHED_CURRENT_LOCATION',
  props<{ location?: any }>()
);
